import {
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_SUCCESSFUL,
  SUBMIT_FEEDBACK_FAILED,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESSFUL,
  VERIFY_CODE_FAILED,
  INTERVIEW_FEEDBACK,
  INTERVIEW_FEEDBACK_SUCCESSFUL,
  INTERVIEW_FEEDBACK_FAILED,
  SHORTLIST_FEEDBACK,
  SHORTLIST_FEEDBACK_FAILED,
  SHORTLIST_FEEDBACK_SUCCESSFUL,
  VERIFY_CODE_SHORTLIST,
  VERIFY_CODE_SHORTLIST_SUCCESSFUL,
  VERIFY_CODE_SHORTLIST_FAILED,
  GET_INTERVIEWERS_LIST,
  GET_INTERVIEWERS_LIST_SUCCESS,
  GET_INTERVIEWERS_LIST_FAIL,
  GET_FEEDBACK_CANDIDATE_DATA,
  GET_FEEDBACK_CANDIDATE_DATA_SUCCESS,
  GET_FEEDBACK_CANDIDATE_DATA_FAIL,
  GET_SHORTLIST_DATA,
  GET_SHORTLIST_DATA_SUCCESS,
  GET_SHORTLIST_DATA_FAIL,
  GET_CANDIDATE_RESUME_DETAILS,
  GET_CANDIDATE_RESUME_DETAILS_SUCCESS,
  GET_CANDIDATE_RESUME_DETAILS_FAIL,
  GET_CANDIDATES_MODAL_DATA,
  GET_CANDIDATES_MODAL_DATA_SUCCESS,
  GET_CANDIDATES_MODAL_DATA_FAIL,
  GET_SHORLISTING_CANDIDATES_LIST,
  GET_SHORLISTING_CANDIDATES_LIST_SUCCESS,
  GET_SHORLISTING_CANDIDATES_LIST_FAIL,
  GET_OFFER_DATA,
  GET_OFFER_DATA_SUCCESS,
  GET_OFFER_DATA_FAIL,
  POST_OFFER_DATA,
  POST_OFFER_DATA_SUCCESS,
  POST_OFFER_DATA_FAIL,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS,
  GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS,
  GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL,
  SUBMIT_HIRING_FEEDBACK_DATA,
  SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS,
  SUBMIT_HIRING_FEEDBACK_DATA_FAIL,
  GET_HIRE_CANDIDATE_LIST,
  GET_HIRE_CANDIDATE_LIST_SUCCESS,
  GET_HIRE_CANDIDATE_LIST_FAIL,
  GET_HIRING_SHORTLIST_DATA,
  GET_SHORTLIST_FILTER_DATA,
  GET_HIRE_CANDIDATE_RESUME_DETAILS,
  GET_INTERVIEW_QUESTION_LIST,
  GET_INTERVIEW_QUESTION_LIST_SUCCESS,
  GET_INTERVIEW_QUESTION_LIST_FAIL,
  GET_INTERVIEW_QUESTION_REVIEW_LIST,
  GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL,
  GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS,
  GET_INTERVIEW_QUESTION_LIST_ID,
  GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS,
  GET_INTERVIEW_QUESTION_LIST_ID_FAIL,
  GET_HIRING_INTERVIEWER_LIST,
  GET_HIRING_INTERVIEWER_LIST_SUCCESS,
  GET_HIRING_INTERVIEWER_LIST_FAIL,
} from "./actionTypes";

const initialState = {
  loader: false,
  feedBack: null,
  successMessage: null,
  errorMessage: null,
  verify: null,
  feedBackMessage: null,
  interviewerList: null,
  errormsg: null,
  candidateData: null,
  shortListData: null,
  candidateResumeDetails: null,
  shortlistedCandidates: null,
  errorMsg: null,
  offerData: null,
  candidateViewModalData: null,
  offerSuccess: null,
  offerFail: null,
  HirecandidateList: null,
  status: null,
  resumeLoader: false,
  interviewQuestion: null,
  interviewQuestionError: null,
  interviewQuestionReview: null,
  interviewQuestionReviewError: null,
  interviewQuestionId: null,
  interviewQuestionIdError: null,
  interviewLoader: false,
};

const submitFeedBackReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HIRE_SUBMIT_FEEDBACK_STATUS:
      state = {
        ...state,
        // loader: true,
        status: null,
        errorMsg: null,
      };
      break;
    case GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS:
      state = {
        ...state,
        // loader: true,
        status: null,
        errorMsg: null,
      };
      break;
    case GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS:
      state = {
        ...state,
        // loader: true,
        status: null,
        errorMsg: null,
      };
      break;
    case GET_HIRE_SUBMIT_FEEDBACK_STATUS_SUCCESS:
      state = {
        ...state,
        loader: false,
        status: action.payload,
        errorMsg: null,
      };
      break;
    case GET_HIRE_SUBMIT_FEEDBACK_STATUS_FAIL:
      state = {
        ...state,
        loader: false,
        status: null,
        errorMsg: action.payload,
      };
      break;

    case SUBMIT_HIRING_FEEDBACK_DATA:
      state = {
        ...state,
        // loader: true,
        feedBackMessage: null,
        errorMsg: null,
      };
      break;
    case SUBMIT_HIRING_FEEDBACK_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        feedBackMessage: action.payload,
        errorMsg: null,
      };
      break;
    case SUBMIT_HIRING_FEEDBACK_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        feedBackMessage: null,
        errorMsg: action.payload,
      };
      break;

    case GET_HIRE_CANDIDATE_LIST:
      state = {
        ...state,
        loader: true,
        HirecandidateList: null,
        errorMsg: null,
      };
      break;
    case GET_HIRE_CANDIDATE_LIST_SUCCESS:
      state = {
        ...state,
        loader: false,
        HirecandidateList: action.payload,
        errorMsg: null,
      };
      break;
    case GET_HIRE_CANDIDATE_LIST_FAIL:
      state = {
        ...state,
        loader: false,
        HirecandidateList: null,
        errorMsg: action.payload,
      };
      break;

    case GET_CANDIDATES_MODAL_DATA:
      state = {
        ...state,
        // loader: true,
        candidateViewModalData: null,
        errorMsg: null,
      };
      break;
    case GET_CANDIDATES_MODAL_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        candidateViewModalData: action.payload,
        errorMsg: null,
      };
      break;
    case GET_CANDIDATES_MODAL_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        candidateViewModalData: null,
        errorMsg: action.payload,
      };
      break;

    case GET_SHORLISTING_CANDIDATES_LIST:
      state = {
        ...state,
        loader: true,
        shortlistedCandidates: null,
        errorMsg: null,
      };
      break;

    case GET_SHORTLIST_FILTER_DATA:
      state = {
        ...state,
        // loader: true,
        shortlistedCandidates: null,
        errorMsg: null,
      };
      break;

    case GET_SHORLISTING_CANDIDATES_LIST_SUCCESS:
      state = {
        ...state,
        loader: false,
        shortlistedCandidates: action.payload,
        errorMsg: null,
      };
      break;
    case GET_SHORLISTING_CANDIDATES_LIST_FAIL:
      state = {
        ...state,
        loader: false,
        shortlistedCandidates: null,
        errorMsg: null,
      };
      break;

    case GET_HIRE_CANDIDATE_RESUME_DETAILS:
      state = {
        ...state,
        // loader: true,
        resumeLoader: true,
        candidateResumeDetails: null,
        errormsg: null,
      };
      break;
    case GET_CANDIDATE_RESUME_DETAILS:
      state = {
        ...state,
        // loader: true,
        resumeLoader: true,
        candidateResumeDetails: null,
        errormsg: null,
      };
      break;
    case GET_CANDIDATE_RESUME_DETAILS_SUCCESS:
      state = {
        ...state,
        resumeLoader: false,
        // loader: false,
        candidateResumeDetails: action.payload,
        errormsg: null,
      };
      break;

    case GET_CANDIDATE_RESUME_DETAILS_FAIL:
      state = {
        ...state,
        // loader: false,
        resumeLoader: false,
        candidateResumeDetails: null,
        errormsg: action.payload,
      };
      break;

    case GET_INTERVIEWERS_LIST:
      state = {
        ...state,
        loader: true,
        interviewerList: null,
        errormsg: null,
      };
      break;
    case GET_INTERVIEWERS_LIST_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewerList: action.payload,
        errormsg: null,
      };
      break;

    case GET_INTERVIEWERS_LIST_FAIL:
      state = {
        ...state,
        loader: false,
        interviewerList: null,
        errormsg: action.payload,
      };
      break;

    case GET_HIRING_INTERVIEWER_LIST:
      state = {
        ...state,
        loader: true,
        interviewerList: null,
        errormsg: null,
      };
      break;

    case GET_HIRING_INTERVIEWER_LIST_SUCCESS:
      state = {
        ...state,
        loader: false,
        interviewerList: action.payload,
        errormsg: null,
      };
      break;

    case GET_HIRING_INTERVIEWER_LIST_FAIL:
      state = {
        ...state,
        loader: false,
        interviewerList: null,
        errormsg: action.payload,
      };
      break;

    case GET_FEEDBACK_CANDIDATE_DATA:
      state = {
        ...state,
        loader: true,
        candidateData: null,
        errormsg: null,
      };
      break;
    case GET_FEEDBACK_CANDIDATE_DATA:
      state = {
        ...state,
        loader: true,
        candidateData: null,
        errormsg: null,
      };
      break;
    case GET_FEEDBACK_CANDIDATE_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        candidateData: action.payload,
        errormsg: null,
      };
      break;

    case GET_FEEDBACK_CANDIDATE_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        candidateData: null,
        errormsg: action.payload,
      };
      break;
    case GET_SHORTLIST_DATA:
      state = {
        ...state,
        loader: true,
        shortListData: null,
        errormsg: null,
      };
      break;
    case GET_HIRING_SHORTLIST_DATA:
      state = {
        ...state,
        loader: true,
        shortListData: null,
        errormsg: null,
      };
      break;
    case GET_SHORTLIST_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        shortListData: action.payload,
        errormsg: null,
      };
      break;

    case GET_SHORTLIST_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        shortListData: null,
        errormsg: action.payload,
      };
      break;

    case SUBMIT_FEEDBACK:
      state = {
        ...state,
        loader: true,
        feedBack: action.payload,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case SUBMIT_FEEDBACK_SUCCESSFUL:
      state = {
        ...state,
        loader: false,
        feedBack: null,
        successMessage: action.payload,
        errorMessage: null,
      };
      break;
    case SUBMIT_FEEDBACK_FAILED:
      state = {
        ...state,
        loader: false,
        feedBack: null,
        successMessage: null,
        errorMessage: action.payload,
      };
      break;
    case VERIFY_CODE:
      state = {
        ...state,
        loader: true,
        verify: action.payload,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case VERIFY_CODE_SUCCESSFUL:
      state = {
        ...state,
        loader: false,
        verify: null,
        successMessage: action.payload,
        errorMessage: null,
      };
      break;
    case VERIFY_CODE_FAILED:
      state = {
        ...state,
        loader: false,
        verify: null,
        successMessage: null,
        errorMessage: action.payload,
      };
      break;
    case INTERVIEW_FEEDBACK:
      state = {
        ...state,
        interviewLoader: true,
        feedBack: action.payload,
        feedBackMessage: null,
        errorMessage: null,
      };
      break;
    case INTERVIEW_FEEDBACK_SUCCESSFUL:
      state = {
        ...state,
        interviewLoader: false,
        feedBackMessage: action.payload,
        errorMessage: null,
      };
      break;
    case INTERVIEW_FEEDBACK_FAILED:
      state = {
        ...state,
        interviewLoader: false,
        feedBackMessage: null,
        errorMessage: action.payload,
      };
      break;
    case VERIFY_CODE_SHORTLIST:
      state = {
        ...state,
        loader: true,
        verify: action.payload,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case VERIFY_CODE_SHORTLIST_SUCCESSFUL:
      state = {
        ...state,
        loader: false,
        verify: null,
        successMessage: action.payload,
        errorMessage: null,
      };
      break;
    case VERIFY_CODE_SHORTLIST_FAILED:
      state = {
        ...state,
        loader: false,
        verify: null,
        successMessage: null,
        errorMessage: action.payload,
      };
      break;
    case SHORTLIST_FEEDBACK:
      state = {
        ...state,
        loader: true,
        feedBack: action.payload,
        feedBackMessage: null,
        errorMessage: null,
      };
      break;
    case SHORTLIST_FEEDBACK_SUCCESSFUL:
      state = {
        ...state,
        loader: false,
        feedBackMessage: action.payload,
        errorMessage: null,
      };
      break;
    case SHORTLIST_FEEDBACK_FAILED:
      state = {
        ...state,
        loader: false,
        feedBackMessage: null,
        errorMessage: action.payload,
      };
      break;
    case GET_OFFER_DATA:
      state = {
        ...state,
        loader: true,
        offerData: action.payload,
        errorMsg: null,
      };
      break;
    case GET_OFFER_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        offerData: action.payload,
        errorMsg: null,
      };
      break;
    case GET_OFFER_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        offerData: null,
        errorMsg: action.payload,
      };
      break;

    case POST_OFFER_DATA:
      state = {
        ...state,
        offerSuccess: null,
        offerFail: null,
      };
      break;
    case POST_OFFER_DATA_SUCCESS:
      state = {
        ...state,
        offerSuccess: action.payload,
        offerFail: null,
      };
      break;
    case POST_OFFER_DATA_FAIL:
      state = {
        ...state,
        offerSuccess: null,
        offerFail: action.payload,
      };
      break;

    case GET_INTERVIEW_QUESTION_LIST:
      state = {
        ...state,
        interviewQuestion: null,
        interviewQuestionError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_LIST_SUCCESS:
      state = {
        ...state,
        interviewQuestion: action.payload,
        interviewQuestionError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_LIST_FAIL:
      state = {
        ...state,
        interviewQuestion: null,
        interviewQuestionError: action.payload,
      };
      break;

    case GET_INTERVIEW_QUESTION_REVIEW_LIST:
      state = {
        ...state,
        interviewQuestionReview: null,
        interviewQuestionReviewError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_REVIEW_LIST_SUCCESS:
      state = {
        ...state,
        interviewQuestionReview: action.payload,
        interviewQuestionReviewError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_REVIEW_LIST_FAIL:
      state = {
        ...state,
        interviewQuestionReview: null,
        interviewQuestionReviewError: action.payload,
      };
      break;

    case GET_INTERVIEW_QUESTION_LIST_ID:
      state = {
        ...state,
        interviewQuestionId: null,
        interviewQuestionIdError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_LIST_ID_SUCCESS:
      state = {
        ...state,
        interviewQuestionId: action.payload,
        interviewQuestionIdError: null,
      };
      break;
    case GET_INTERVIEW_QUESTION_LIST_ID_FAIL:
      state = {
        ...state,
        interviewQuestionId: null,
        interviewQuestionIdError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
export default submitFeedBackReducer;
